import React from 'react';
import { motion } from 'framer-motion';
import { CyberpunkButton } from './CyberpunkButton';
import { Terminal, Cpu, Zap } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden py-20" data-id="element-40">
      {/* Background Elements */}
      <div className="absolute inset-0 cyber-grid opacity-30" data-id="element-41" />
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-[#050814] via-transparent to-[#050814]" data-id="element-42" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-43">
        <div className="max-w-4xl mx-auto text-center" data-id="element-44">
          {/* Glitchy Label */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="inline-flex items-center gap-2 mb-6 px-4 py-2 border border-[#00f0ff]/30 bg-[#00f0ff]/5 rounded-full" data-id="element-45">
            <span className="w-2 h-2 rounded-full bg-[#00f0ff] animate-pulse" data-id="element-46" />
            <span className="text-[#00f0ff] text-sm font-mono tracking-widest uppercase" data-id="element-47">
              System Online v2.0.77
            </span>
          </motion.div>

          {/* Main Heading */}
          <motion.h1 initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-5xl md:text-7xl lg:text-8xl font-black mb-8 leading-tight" data-id="element-48">
            <span className="block text-white mb-2" style={{
            textShadow: '0 0 20px rgba(255,255,255,0.3)'
          }} data-id="element-49">
              FUTURE OF
            </span>
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#00f0ff] to-[#ff006e] relative" data-id="element-50">
              GAMING
              <motion.span className="absolute inset-0 text-[#00f0ff] opacity-50 blur-lg" animate={{
              opacity: [0.3, 0.6, 0.3]
            }} transition={{
              duration: 2,
              repeat: Infinity
            }} data-id="element-51">
                GAMING
              </motion.span>
            </span>
          </motion.h1>

          {/* Subheading */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="text-lg md:text-xl text-gray-400 mb-12 max-w-2xl mx-auto font-mono leading-relaxed" data-id="element-52">
            Immerse yourself in the next generation of digital entertainment.
            Where reality ends and the{' '}
            <span className="text-[#ff006e]" data-id="element-53">simulation begins</span>.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="flex flex-col sm:flex-row gap-6 justify-center items-center" data-id="element-54">
            <CyberpunkButton variant="blue" data-id="element-55">
              <Terminal className="w-4 h-4" data-id="element-56" />
              Initialize Protocol
            </CyberpunkButton>
            <CyberpunkButton variant="pink" data-id="element-57">
              <Zap className="w-4 h-4" data-id="element-58" />
              View Catalogue
            </CyberpunkButton>
          </motion.div>

          {/* Decorative Tech Elements */}
          <div className="mt-20 grid grid-cols-3 gap-8 text-center opacity-50" data-id="element-59">
            {[{
            icon: Cpu,
            label: 'Neural Processing'
          }, {
            icon: Terminal,
            label: 'Quantum Core'
          }, {
            icon: Zap,
            label: 'Hyper Speed'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.8 + i * 0.2
          }} className="flex flex-col items-center gap-2" data-id="element-60">
                <item.icon className="w-6 h-6 text-[#00f0ff]" data-id="element-61" />
                <span className="text-xs font-mono uppercase tracking-widest" data-id="element-62">
                  {item.label}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}